import { Stack } from '@mui/material';
import React, { PropsWithChildren, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GeneralErrorUI } from '../../components/errors/generalError';
import { EntitlementContext } from './entitlement-context';

export function EntitlementProvider({
  children,
}: PropsWithChildren): React.JSX.Element {
  const { t } = useTranslation();
  const [isNotEntitled, setIsNotEntitled] = useState(false);

  const handleSetNotEntitled = useCallback(() => {
    setIsNotEntitled(true);
  }, []);

  if (isNotEntitled) {
    return (
      <Stack height='100%' component='div'>
        <GeneralErrorUI
          title={t('errors.entitlement.title')}
          description={t('errors.entitlement.description')}
        />
      </Stack>
    );
  }

  return (
    <EntitlementContext.Provider value={handleSetNotEntitled}>
      {children}
    </EntitlementContext.Provider>
  );
}
